export default __webpack_public_path__ + "static/media/89028eeee031b0b46ce1b95f76dff29a.svg";